if (!window.growtype_quiz_data) {
    window.growtype_quiz_data = new Event('growtypeQuizSaveQuizData');
    window.growtype_quiz_data.answers = sessionStorage.getItem('growtype_quiz_answers') === null ? {} : JSON.parse(sessionStorage.getItem('growtype_quiz_answers'));
    window.growtype_quiz_data.correctlyAnswered = {};
    window.growtype_quiz_data.extra_details = {};
    window.growtype_quiz_data.quiz_id = window.growtype_quiz_local.quiz_id
}

export function saveQuizDataEvent() {
    return window.growtype_quiz_data;
}
